import React from 'react'

const RadioButton = ({ iconSize, uid, ...props }) => {
  const style = {
    backgroundSize: iconSize,
    width: iconSize,
    height: iconSize,
  }

  return (
    <span className="radio-button">
      <input id={uid} type="radio" {...props} />
      <label htmlFor={uid} style={style} />
    </span>
  )
}

export default RadioButton
